import React from 'react';
import ManCrossPageFooter from '../components/ManCrossPageFooter';

const IVC_COLOR = {
    '-Niv.3':       '#e74c3c',
    '-Niv.2':       '#e67e22',
    'Reduce expo':  '#e67e22',
    'Monitor.':     '#18af4b',
};

const ManCrossPageActionPlan = ({ reportData, headerText, pageNumber }) => {
    const payload      = reportData?.payload || {};
    const rows         = payload.plan_90_dias           || [];
    const decisions    = payload.decisiones_gerenciales || [];
    const callout      = payload.callout_90             || '';
    const implication  = payload.implication_90         || '';

    return (
        <div className="mgcr-drivers-page">
            <div className="mgcr-page-header">
                <span className="mgcr-page-header-text">{headerText}</span>
                <span className="mgcr-page-header-num">{pageNumber}</span>
            </div>

            <div className="keep-blankspace" />

            <div className="mgcr-dx-title-area">
                <h2 className="mgcr-dx-main-title">Plan de Acción</h2>
                <p className="mgcr-dx-subtitle">Ejecución 90 Días</p>
            </div>

            {callout && (
                <div className="mgcr-roi-callout" style={{ marginBottom: 12 }}>
                    {callout}
                </div>
            )}

            {/* Tabla de intervención */}
            <div className="mgcr-ap-section-label">Tabla de Intervención</div>

            <div className="mgcr-ap-table-wrap">
                <table className="mgcr-ap-table">
                    <thead>
                        <tr className="mgcr-ap-thead-row">
                            <th className="mgcr-ap-th mgcr-ap-th--accion">Acción</th>
                            <th className="mgcr-ap-th">Población</th>
                            <th className="mgcr-ap-th">Resp.</th>
                            <th className="mgcr-ap-th mgcr-ap-th--semana">Semana</th>
                            <th className="mgcr-ap-th mgcr-ap-th--num">ICP +</th>
                            <th className="mgcr-ap-th mgcr-ap-th--num">IVC</th>
                            <th className="mgcr-ap-th">KPI de Éxito</th>
                            <th className="mgcr-ap-th">Tipo</th>
                            <th className="mgcr-ap-th">Tiempo Res.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={i} className={`mgcr-ap-row ${i % 2 === 0 ? '' : 'mgcr-ap-row--alt'}`}>
                                <td className="mgcr-ap-td mgcr-ap-td--accion">{row.accion}</td>
                                <td className="mgcr-ap-td">{row.poblacion}</td>
                                <td className="mgcr-ap-td">{row.resp}</td>
                                <td className="mgcr-ap-td mgcr-ap-td--center">{row.semana}</td>
                                <td className="mgcr-ap-td mgcr-ap-td--center mgcr-ap-td--icp">
                                    {row.icp_plus}
                                </td>
                                <td className="mgcr-ap-td mgcr-ap-td--center">
                                    <span
                                        className="mgcr-ap-ivc-badge"
                                        style={{ color: IVC_COLOR[row.ivc] || '#339C98' }}
                                    >
                                        {row.ivc}
                                    </span>
                                </td>
                                <td className="mgcr-ap-td">{row.kpi_exito}</td>
                                <td className="mgcr-ap-td mgcr-ap-td--center">
                                    <span
                                        className="mgcr-ap-tipo-badge"
                                        style={{ backgroundColor: row.tipo_color || '#339C98' }}
                                    >
                                        {row.tipo}
                                    </span>
                                </td>
                                <td className="mgcr-ap-td mgcr-ap-td--center">{row.tiempo_res}</td>
                            </tr>
                        ))}
                        {/* Fila de cierre púrpura */}
                        <tr>
                            <td colSpan={9} className="mgcr-ap-close-row" />
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Decisiones gerenciales */}
            {decisions.length > 0 && (
                <div className="mgcr-ap-decisions">
                    <div className="mgcr-ap-decisions-title">DECISIONES GERENCIALES</div>
                    <ul className="mgcr-ap-decisions-list">
                        {decisions.map((d, i) => (
                            <li key={i} className="mgcr-ap-decisions-item">{d}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Esto implica que */}
            {implication && (
                <div className="mgcr-roi-implication" style={{ marginTop: 10 }}>
                    <strong>Esto implica que:</strong> {implication}
                </div>
            )}

            <div className="keep-blankspace" />
            <ManCrossPageFooter />
        </div>
    );
};

export default ManCrossPageActionPlan;
